import styles from './kulekiste.module.css';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import HeroBanner from '../../../components/HeroBanner/HeroBanner';
function KuleKiste() {
    const [hasImages, setHasImages] = useState(false);
    const navigate = useNavigate();
    return (
        <div>
            <HeroBanner category="kule-kiste" onImagesLoaded={setHasImages} />
            <section className={styles.center} style={{ marginTop: hasImages ? '20px' : 'var(--marginTopDefault)' }}>
                <h1>Kule Kiste (13:00 Betreuung)</h1>
                <div>
                    <p>Neben der offenen Ganztagsschule bekommen Sie bei uns auch das Angebot der Übermittagsbetreuung  (Kule Kiste). Hier werden die Kinder nach Schulschluss bis 13:10 Uhr in den Räumen des Vereinsheims betreut. Nach dem Unterrichtsende haben die Kinder die Möglichkeit, ihr mitgebrachtes 2. Frühstück zu essen.<br /><br />Während der Übermittagsbetreuung findet keine Lernzeitbetreuung statt. Die Kinder haben allerdings die Möglichkeit, freiwillig und ohne Hilfe ihre Lernzeitaufgaben zu erledigen. Zudem können die Kinder an Spiel- und Bastelangeboten teilnehmen oder nutzen die Möglichkeit des Freispiels in den Gruppenräumen oder auf dem großzügigen Außengelände.</p>
                </div>


                <section>
                    <h2>Das Team</h2>
                    <p>Die Nachmittagsbetreuung am Gymnasium am Ölberg bietet Kindern der 5. und 6. Klassen im Anschluss an die Unterrichtszeit von 13:10 – 15:45 Uhr montags bis freitags (dann jedoch mit dem besonderen Fun Fact Friday) Lernzeitbetreuung und ein offenes Sportangebot (ab 14.40 Uhr).<br /><br />Durch die Nutzung von Klassenräumen mit Schulhofausgang haben die Kinder auch vor dem angeleiteten Sportangebot Möglichkeit zur Bewegung mit Fußball, Basketball, Tischtennis…. Kreative Angebote mit vielfältigem Material und eine große Spieleauswahl machen den Nachmittag für die Kinder abwechslungsreich.<br /><br />Da die Kinder bei ihrem Übergang in die weiterführende Schule in ihrem Hereinwachsen in Selbständigkeit aktiv in der Betreuung unterstützt werden sollen, gibt es keine starren Betreuungszeiten, sondern Betreuungstage, die einzeln „gebucht“ werden können. In Absprache mit den Eltern werden die Zeiten festgelegt und sind im o. g. Zeitraum) variabel.</p>
                </section>


                <section>
                    <h2>Anmeldung / Elternbeiträge</h2>
                    <p>Alles wichtige bzgl. der Anmeldung sowie den Kosten finden Sie hier: <span tabIndex={0} className={styles.link} onClick={() => navigate("/ogs/anmeldung-und-elternbeitraege#anmeldung")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {

                                e.preventDefault(); // Prevent space from scrolling
                                navigate("/ogs/anmeldung-und-elternbeitraege#anmeldung")
                            }
                        }}
                    >Anmeldung / Elternbeiträge</span></p>
                </section>

                <section className={styles.bet}>
                    <h2>Betreuungszeiten</h2>
                    <table>
                        <tr>
                            <td className={styles.firstTableItem}>Beginn:</td>
                            <td>nach Schulschluss des Kindes</td>
                        </tr>
                        <tr>
                            <td className={styles.firstTableItem}>Ende:</td>
                            <td>max. nach der 6. Stunde</td>
                        </tr>
                        <tr>
                            <td className={styles.firstTableItem}>Abholzeiten:</td>
                            <td>13:00 Uhr</td>
                        </tr>
                    </table>
                    <p><strong>Zusätzliche Betreuungszeiten</strong></p>
                    <ul>
                        <li>Notbetreuung von 7:30 - 13:10 Uhr an Konzeptions- oder Fortbildungstagen der Schule sowie an beweglichen Ferientagen</li>
                        <li>Kostenpflichtige ganztägige Ferienbetreuung von 7:30 - 16:00 Uhr am Standort Oberpleis
                            <ul>
                                <li>1. Herbstferienwoche, 1. Osterferienwoche, 1. und 2. Sommerferienwoche</li>
                                <li>Die Ferienbetreuung wird jedes Jahr vom OGS-Team zu einem bestimmten Thema gestaltet.</li>
                                <li>Hier erlernen die Kinder in verschiedenen pädagogischen Workshops, als auch bei Ausflügen unterschiedliche Fähigkeiten und Fertigkeiten.</li>
                            </ul>
                        </li>
                    </ul>
                </section>
            </section>
        </div>
    )
}

export default KuleKiste;